import { useEffect, useState } from "react";
import PropertyCard from "../components/Property/PropertyList";

/* ================= PROPERTY LIST ================= */
const PropertyList = () => {
  const [properties, setProperties] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
   fetch("https://thakkar-backend.vercel.app/api/properties")
      .then((res) => res.json())
      .then((res) => {
        setProperties(Array.isArray(res.data) ? res.data : []);
        setLoading(false);
      })
      .catch(() => setLoading(false));
  }, []);

  if (loading)
    return <p className="text-center mt-10">Loading properties...</p>;

  if (!properties.length)
    return <p className="text-center mt-10">No properties found</p>;

  return (
    <div className="max-w-6xl mx-auto p-6 space-y-10 mt-28">
      {properties.map((property) => (
        <PropertyCard key={property._id} property={property} />
      ))}
    </div>
  );
};

export default PropertyList;